export const GET_ALL_PAYMENT_INTENT_REQUESTED = 'views/Home/GET_ALL_PAYMENT_INTENT_REQUESTED';
export const GET_ALL_PAYMENT_INTENT_SUCCESS = 'views/Home/  GET_ALL_PAYMENT_INTENT_SUCCESS';
export const GET_ALL_PAYMENT_INTENT_FAILED = 'views/Home/   GET_ALL_PAYMENT_INTENT_FAILED';
